import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@catawiki/cata-style';
import { BUYER_PROTECTION_PATH, BUYER_TERMS_PATH, HOW_TO_BUY_PATH, STORIES_PATH, } from '../paths';
import { FooterColumn } from '../shared/FooterColumn';
import { useLocale } from '../../../../hooks/useLocale';
export const Buy = () => {
    const { t } = useI18n();
    const locale = useLocale();
    const items = [
        { content: t('footer_link_how_to_buy'), link: HOW_TO_BUY_PATH(locale) },
        {
            content: t('footer_link_buyer_protection'),
            link: BUYER_PROTECTION_PATH(locale),
        },
        { content: t('footer_link_catawiki_stories'), link: STORIES_PATH(locale) },
        { content: t('footer_link_buyer_terms'), link: BUYER_TERMS_PATH(locale) },
    ];
    return _jsx(FooterColumn, { title: t('footer_link_buy'), items: items });
};
//# sourceMappingURL=Buy.js.map